import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class DesignModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][DesignModel] organizationId is mandatory`);
        }

        if (eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/designs`;
        }
        return `/ticket/organizations/${organizationId}/designs`;
    }

    static perform_preview(data, { organization, event }) {
        if (event) {
            return fetcher.post(`/ticket/organizations/${organization.id}/events/${event.id}/designs/preview`, data);
        }
        return fetcher.post(`/ticket/organizations/${organization.id}/designs/preview`, data);
    }
}
